import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#0a0a0a] border-t border-white/10 pt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16">
          <div className="md:col-span-5">
            <img src="/logo.png" alt="Switch Tech Talent" className="h-14 w-auto mb-6" />
            <p className="text-white/60 text-sm leading-relaxed max-w-sm font-body">
              A specialist tech recruitment partner connecting ambitious organisations with exceptional talent across AI, Data, Software and Product, UK, Europe &amp; the US.
            </p>
            <div className="mt-8 flex items-center gap-4 text-white/60">
              <a href="mailto:hello@switchtt.co.uk" className="hover:text-[#3B82F6] transition-colors" data-testid="footer-email">
                <Mail size={18} />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="hover:text-[#3B82F6] transition-colors" data-testid="footer-linkedin">
                <Linkedin size={18} />
              </a>
            </div>
          </div>
          <div className="md:col-span-2">
            <div className="font-mono text-[10px] text-[#3B82F6] uppercase tracking-[0.25em] mb-4">Explore</div>
            <ul className="space-y-3 text-white/70 text-sm">
              <li><Link to="/" className="hover:text-white" data-testid="footer-link-home">Home</Link></li>
              <li><a href="https://www.linkedin.com/company/switchtt/jobs" target="_blank" rel="noreferrer" className="hover:text-white" data-testid="footer-link-jobs">Live Roles ↗</a></li>
              <li><Link to="/services" className="hover:text-white" data-testid="footer-link-services">Services</Link></li>
              <li><Link to="/about" className="hover:text-white" data-testid="footer-link-about">About</Link></li>
              <li><Link to="/contact" className="hover:text-white" data-testid="footer-link-contact">Contact</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="font-mono text-[10px] text-[#3B82F6] uppercase tracking-[0.25em] mb-4">Sectors</div>
            <ul className="space-y-3 text-white/70 text-sm">
              <li>AI &amp; Machine Learning</li>
              <li>Data &amp; Analytics</li>
              <li>Software Engineering</li>
              <li>Product &amp; Design</li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <div className="font-mono text-[10px] text-[#3B82F6] uppercase tracking-[0.25em] mb-4">Office</div>
            <div className="text-white/70 text-sm space-y-3">
              <div className="flex items-start gap-2">
                <MapPin size={16} className="mt-0.5 shrink-0" />
                <div>4 Queens Rd<br />London SW19 8YE<br />United Kingdom</div>
              </div>
              <div>hello@switchtt.co.uk</div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 py-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="text-white/40 text-xs font-mono uppercase tracking-widest">© {new Date().getFullYear()} Switch Tech Talent Ltd</p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="text-white/40 hover:text-white text-xs font-mono uppercase tracking-widest" data-testid="footer-privacy-link">
              Privacy Policy
            </Link>
            <p className="text-white/40 text-xs font-mono uppercase tracking-widest">Finding · Connecting · Scaling</p>
          </div>
        </div>
      </div>

      <div className="overflow-hidden select-none">
        <div className="marquee-text text-[18vw] text-transparent leading-none py-4" style={{ WebkitTextStroke: "1px rgba(255,255,255,0.06)" }}>
          SWITCH&nbsp;SWITCH&nbsp;SWITCH
        </div>
      </div>
    </footer>
  );
};
